// Thank you: https://github.com/livelybone/vuejs-snackbar/blob/master/src/components/Snackbar.vue

<template>
  <div class="snack-bar-wrapper" :class="wrapClass" :style="wrapClass ? '' : style.wrap">
    <div v-for="(snack, idx) in snacks" :key="idx + 's'" aria-live="assertive" aria-atomic="true">
      <div
        class="snack-bar"
        :style="wrapClass ? '' : style.bar(snack.color)"
        @click="pop(snack.id)"
        v-html="snack.message"
      ></div>
      <br />
    </div>
  </div>
</template>

<script>
const getStyle = (baseSize, position) => {
  const c = f => `calc(${f} * ${baseSize})`;
  const { pos, textAlign } = position;
  return {
    wrap: {
      position: "fixed",
      left: 0,
      [pos]: c(0.05),
      zIndex: 1000,
      width: "100%",
      padding: `0 ${c(0.2)}`,
      pointerEvents: "none",
      textAlign
    },
    bar: bg => ({
      display: "inline-block",
      width: "auto",
      minWidth: baseSize,
      maxWidth: `calc(100vw - ${c(0.4)})`,
      padding: `${c(0.15)} ${c(0.2)}`,
      margin: `0 0 ${c(0.05)}`,
      borderRadius: c(0.02),
      lineHeight: c(0.2),
      color: "#fff",
      background: bg,
      boxShadow: `0 ${c(0.01)} ${c(0.025)} rgba(0,0,0, .15)`,
      cursor: "pointer",
      textAlign: "center",
      pointerEvents: "all",
      userSelect: "none"
    })
  };
};

export default {
  name: "SnackbarComponent",
  data() {
    return {
      snacks: []
    };
  },

  props: {
    colors: {
      type: Object,
      default: () => ({
        error: "red",
        warning: "orange",
        info: "green"
      })
    },
    openTime: {
      type: Number,
      default: 3000
    },
    multiple: {
      type: Boolean,
      default: true
    },
    wrapClass: String,
    baseSize: {
      default: "100px",
      type: String
    },
    position: {
      default: "bottom-center",
      type: String
    }
  },

  computed: {
    $_baseSize() {
      return /\d(rem|px|em)$/.test(this.baseSize) ? this.baseSize : "100px";
    },
    $_position() {
      const [p, textAlign] = this.position.toString().split("-");
      return {
        pos: ["top", "bottom"].includes(p) ? p : "top",
        textAlign: ["left", "center", "right"].includes(textAlign) ? textAlign : "center"
      };
    },
    style() {
      return getStyle(this.$_baseSize, this.$_position);
    }
  },

  methods: {
    addInfo(message, keepOpen) {
      return this.add({ message, type: "info", keepOpen });
    },

    addWarning(message, keepOpen) {
      return this.add({ message, type: "warning", keepOpen });
    },

    addError(message, keepOpen) {
      return this.add({ message, type: "error", keepOpen });
    },

    update(id, message) {
      const snack = this.snacks.find(snack => snack.id === id);
      if (snack) {
        snack.message = message;
      }
    },

    add(snack) {
      const snackObj = {
        id: Math.floor(Math.random() * 100000),
        message: snack.message,
        type: snack.type,
        color: this.colors[snack.type],
        keepOpen: snack.keepOpen
      };
      if (!snack.keepOpen) {
        snackObj.timer = setTimeout(() => {
          this.remove(snackObj.id);
        }, this.openTime);
      }

      if (this.multiple) {
        this.snacks.push(snackObj);
      } else {
        this.snacks = [snackObj];
      }

      return snackObj.id;
    },

    remove(id) {
      const i = this.snacks.findIndex(snack => snack.id === id);
      if (i > -1) {
        clearTimeout(this.snacks[i].timer);
        this.snacks.splice(i, 1);
      }
    },

    pop(id) {
      if (!this.snacks.find(snack => snack.id === id).keepOpen) {
        this.remove(id);
      }
    }
  }
};
</script>
